import { exportSave } from "./store";

/** Triggers a browser download of the current save as a JSON file. */
export function downloadSave(): void {
  const blob = new Blob([exportSave()], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "breachguard-save.json";
  link.click();
  URL.revokeObjectURL(url);
}
